import { render, staticRenderFns } from "./shared-input-radio.vue?vue&type=template&id=6c8f0825"
import script from "./shared-input-radio.vue?vue&type=script&lang=js"
export * from "./shared-input-radio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports